import * as React from "react"
import { Form } from "react-bootstrap"

interface CheckboxProps {
  id: string
  checked?: boolean
  className?: string
  defaultChecked?: boolean
  disabled?: boolean
  label?: string
  name?: string
  style?: React.CSSProperties
  value?: string
  inline?: boolean
  title?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export default function Checkbox(props: CheckboxProps) {
  return (
    <Form.Check
      {...props}
      type="checkbox"
      className={`abc-checkbox abc-checkbox-primary ${props.className || ""}`}
      label={props.label || ""}
    />
  )
}
